// Puts text on the clipboard. The Clipboard API first; where the browser refuses it (an embedded
// browser, a page without the permission), a hidden textarea and the copy command. Throws when
// neither copies.
export const copyText = async (text: string): Promise<void> => {
	try {
		await navigator.clipboard.writeText(text);
		return;
	} catch (e) {
		// fall through to the copy command
	}
	const area: HTMLTextAreaElement = document.createElement('textarea');
	area.value = text;
	area.setAttribute('readonly', '');
	area.style.position = 'fixed';
	area.style.top = '-1000px';
	area.style.opacity = '0';
	document.body.appendChild(area);
	area.select();
	let copied: boolean = false;
	try {
		copied = document.execCommand('copy');
	} finally {
		document.body.removeChild(area);
	}
	if (!copied) throw new Error('The browser refused to copy');
};
